<template>
    <div class="page white_bg">

        <header class="pageHeader detailPageHeader white_bg bottomBorder101010" style="line-height: 46px;">
            <div class="flexLayout paddingH16">
                <div style="width: 16%">
                    <span class="icon leftAngleBracketIcon floatL" style="margin-top: 12px;" @click="back();"></span>
                </div>
                <div class="flexItem alignCenter font18r primaryTextColor bold hiddenOverflow"
                     style="height: 46px; ">
                    {{title}}
                </div>
                <div class="font14r alignRight" style="width: 16%"></div>
            </div>
        </header>

        <div class="body bgEEE">

            <div class="bgWhite" style="height: 58px;">
                <div class="paddingH12">
                    <div class="font12r" style="line-height: 30px;">
                        <span class="green">信息登记</span>
                        <span class="grey floatR">交易完成</span>
                    </div>
                    <div class="paddingH16" style="height: 15px;">
                        <div class="relativePosition">
                            <span class="point startPoint absolutePosition" style="left: 0; z-index: 2"></span>
                            <span class="point endPoint absolutePosition" style="right:0;  z-index: 2"></span>
                            <div class="line absolutePosition" style="width: 100%; height: 1px; line-height: 1px; background: #0FC060;
                                    top: 7px;"></div>
                        </div>
                    </div>
                    <div style="height: 10px;"></div>
                </div>
            </div>

            <form action="javascript:;" @submit="submit()" v-if="dataItem">
                <div class="generalPagePaddingH bgWhite">

                    <div class="formRow">
                        <div class="columnName">购买产品名称</div>
                        <div class="columnValue relative" style="padding-right:20px;" @click="selectProduct()">
                            <span>{{ dataItem.productName ? dataItem.productName : '点击选择' }}</span>
                            <i class="rightArrowIcon absolutePosition" style="top: 5px; right: 0;"></i>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">交易单号</div>
                        <div class="columnValue color888">
                            <input type="text" class="inputbox block" placeholder="请输入交易单号"
                                   v-model="dataItem.orderNo" required=""/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">交易账号</div>
                        <div class="columnValue color888">
                            <input type="text" class="inputbox block" placeholder="请输入交易银行卡账号或支付宝账号"
                                   v-model="dataItem.orderAccount" required=""/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">支付时间</div>
                        <div class="columnValue alignR color888">
                            <input type="datetime-local" class="inputbox" placeholder="支付时间"
                                   v-model="specialFormData.payTime" required=""/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">支付方式</div>
                        <div class="columnValue alignR">
                            <!--                        <select class="selectbox color888" v-model="dataItem.payWay">-->
                            <!--                            <option value="">&#45;&#45;请选择&#45;&#45;</option>-->
                            <!--                            <option value="">师讯平台</option>-->
                            <!--                            <option value="">企微</option>-->
                            <!--                            <option value="">支付宝</option>-->
                            <!--                            <option value="">公账</option>-->
                            <!--                        </select>-->
                            <dictSelect module="paymentType" class="color888" :required="true" v-model="dataItem.payWay"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">支付金额</div>
                        <div class="columnValue alignR color888">
                            <input type="text" class="inputbox alignR" style="display: inline-block; width: 150px;"
                                   placeholder="请输入支付金额" v-model="dataItem.payAmount" required=""/>
                            元
                        </div>
                    </div>

                </div>

                <div style="height: 17px;"></div>

                <div class="generalPagePaddingH bgWhite">

                    <div class="formRow">
                        <div class="columnName">工种</div>
                        <div class="columnValue alignR">
                            <!--                        <select class="selectbox color888" v-model="dataItem.profession">-->
                            <!--                            <option value="">&#45;&#45;请选择&#45;&#45;</option>-->
                            <!--                            <option value="">XXX证</option>-->
                            <!--                        </select>-->
                            <dictSelect module="workType" class="color888" :required="true" v-model="dataItem.profession"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">出证单位</div>
                        <div class="columnValue alignR color888">

                            <select class="selectbox color888" v-model="dataItem.unitOfCertificate" required="">
                                <option value="">--请选择--</option>
                                <option value="中管院">中管院</option>
                                <option value="电教馆">电教馆</option>
                                <option value="人事人才">人事人才</option>
                                <option value="其他">其他</option>
                            </select>
                        </div>
                    </div>

                </div>
                <div style="height: 17px;"></div>

                <div class="generalPagePaddingH bgWhite">

                    <div class="formRow">
                        <div class="columnName">姓名</div>
                        <div class="columnValue alignR">
                            <input type="text" class="inputbox block" placeholder="请输入名称" required="" v-model="dataItem.name"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">邀请码</div>
                        <div class="columnValue color888 alignR">
                            {{ userInstance ? userInstance.introduceCode : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">手机号</div>
                        <div class="columnValue color888 alignR">
                            <input type="text" class="inputbox block" placeholder="请输入手机号" required="" v-model="dataItem.phone"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">微信号</div>
                        <div class="columnValue color888 alignR">
                            <input type="text" class="inputbox block" placeholder="请输入微信号" required="" v-model="dataItem.wxNo"/>
                        </div>
                    </div>

                </div>
                <div style="height: 17px;"></div>

                <div class="generalPagePaddingH bgWhite">

                    <div class="formRow">
                        <div class="columnName">性别</div>
                        <div class="columnValue alignR">
                            <!--                        <select class="selectbox" v-model="dataItem.sex">-->
                            <!--                            <option value="">&#45;&#45;请选择&#45;&#45;</option>-->
                            <!--                            <option value="男">男</option>-->
                            <!--                            <option value="女">女</option>-->
                            <!--                        </select>-->
                            <dictSelect module="sex" class="color888" :data-sex="dataItem.sex" :required="true"
                                        v-model="dataItem.sex"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">生日</div>
                        <div class="columnValue color888 alignR">
                            <input type="date" class="inputbox inlineBlock" placeholder="请输入生日日期" required=""
                                   v-model="specialFormData.birthday"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">学历</div>
                        <div class="columnValue color888 alignR">
                            <!--                        <select class="selectbox" v-model="dataItem.education">-->
                            <!--                            <option value="">&#45;&#45;请选择&#45;&#45;</option>-->
                            <!--                            <option value="">本科以上</option>-->
                            <!--                            <option value="">本科</option>-->
                            <!--                            <option value="">专科</option>-->
                            <!--                            <option value="">高中</option>-->
                            <!--                            <option value="">中专</option>-->
                            <!--                            <option value="">初中</option>-->
                            <!--                            <option value="">初中以下</option>-->
                            <!--                        </select>-->
                            <dictSelect module="userEducation" class="color888" :required="true" v-model="dataItem.education"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">地区</div>
                        <div class="columnValue color888 alignR" @click="areaSelectingPopup.visible = true">
                            {{ dataItem.region ? dataItem.region : '点击选择省/市/区' }}
                            <i class="rightArrowIcon inlineBlock"></i>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">详细地址</div>
                        <div class="columnValue color888">
                        <textarea class="inputbox w100p" placeholder="请输入街道门牌、楼层房间号等信息" required=""
                                  v-model="dataItem.address"></textarea>
                        </div>
                    </div>

                </div>
                <div style="height: 17px;"></div>


                <div class="generalPagePaddingH bgWhite">

                    <div class="formRow">
                        <div class="columnName">身份证号</div>
                        <div class="columnValue color888">
                            <input type="text" class="inputbox block" placeholder="请输入您的身份证号码" required="" v-model="dataItem.idCard"/>
                        </div>
                    </div>

                    <div class="">
                        <div class="marginB12">上传身份证照片</div>
                        <idCardUploader ref="idCardUploader" @change="onChangeIdCardImgs"/>
                    </div>

                    <div style="color: #B7B6B5;">注：身份证认证是基于用户提现时需要进行实名认证，请您保证您填写的信息真实有效。</div>

                    <div class="marginT24">
                        <div class="">上传证件照（2寸/蓝底）</div>
                        <div>
                            <photoForCredentialsUploader ref="photoForCredentialsUploader" @change="onChangePhotoForCredential"/>
                        </div>
                    </div>

                </div>

                <div class="marginT12 paddingH24 paddingB20">
                    <button class="block w100p saveDraftButton roundBorder4 font14r" @click="saveDraft()">保存草稿</button>
                    <button class="block w100p submitButton roundBorder4 font14r marginT4" type="submit" data-click="submit()">
                        信息登记，提交审核
                    </button>
                </div>
            </form>

        </div><!-- end .body -->

        <topicSelectorDrawer ref="topicSelectorDrawer" @select="onSelectTopic"/>

        <van-popup v-model="areaSelectingPopup.visible" round position="bottom">
            <van-cascader
                v-model="areaSelectingPopup.cascaderValue"
                title="请选择所在地区"
                :options="areaSelectingPopup.options"
                @close="areaSelectingPopup.visible = false"
                @finish="onChangeArea"
            />
        </van-popup>

    </div>
</template>

<script>
// parts and modules
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import dictSelect     from "@comp/dict/dictSelect2";
import idCardUploader from "@/components/form/idCardUploader";
import photoForCredentialsUploader from "@/components/form/photoForCredentialsUploader";
import topicSelectorDrawer from "@pages/topicPackage/topicSelectorDrawer";

import Vue from 'vue';
import {field, popup, cascader } from 'vant';
Vue.use(field);
Vue.use(popup);
Vue.use(cascader);

// config and data
import statusEnum from "@pages/registerInformation/registerInformationStatusEnum";

// API and utils
import storageManager from "@/components/platformApi/storageManager";
import consoleApi from "@/components/platformApi/consoleApi";
import appHelper from "@util/appHelper";
import userUtil from "@comp/shixunApp/userUtil";
import dataMixedUtils from "@util/dataMixedUtils";
import moment from "moment";
import timerManager from "@comp/platformApi/timerManager";
import citiesList from "@data/citiesList_v3";
import htmlHelper from "@util/htmlHelper";
import wechatHelper from "@util/wechatHelper";

const config = {
    name : 'registerInformationEdit',
    title : '购买信息登记',
    description : '',
    apiConfig : {
        get : {
            url : 'portal/information/get',
            dataColumnMapping : {
                // userName : 'name'
            }
        },
        add : {
            url : 'portal/information/save',
            method : 'post'
        },
        update : {
            url : 'portal/information/save',
            method : 'post'
        }

    },
    // 1: 信息登记 2： 退款
    informationType : 2
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {
        dictSelect, idCardUploader, photoForCredentialsUploader,
        topicSelectorDrawer
    },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            enableDataItem : true,
            // autoLoadDataItem : true,
            dataItem : {
                address : '',
                // bank : '',
                // bankAccount : '',
                // bankSubbranch : '',
                birthday : '',
                education : '',
                idCard : '',
                idCardImg1 : '',
                idCardImg2 : '',
                idPhoto : '',
                name : '',
                productName : '',
                orderAccount : '',
                orderNo : '',
                payAmount : '',
                payTime : '',
                payWay : '',
                phone : '',
                profession : '',
                // refundInfo : '',
                region : '',
                salesmanId : '',
                sex : '',
                type : '',
                unitOfCertificate : '',
                userCode : '',
                wxNo : ''
            },

            specialFormData : {
                payTime : '',
                birthday : '',
            },

            //idCardImgs : [],
            userInstance : null,

            areaSelectingPopup : {
                visible : false,
                options : citiesList,
                fieldValue : '',
                cascaderValue : ''
            },

            statusEnum,




        }
    },
    methods : {
        onLoadDataItem() {
            this.specialFormData.birthday = moment(this.dataItem.birthday).format('YYYY-MM-DD');
            this.specialFormData.payTime = moment(this.dataItem.payTime).format('YYYY-MM-DD HH:mm:ss');
            this.$refs.idCardUploader.setValue({
                frontImage : this.dataItem.idCardImg1,
                backImage  : this.dataItem.idCardImg2
            });
            this.$refs.photoForCredentialsUploader.setValue(this.dataItem.idPhoto);
            this.$forceUpdate();
        },
        selectProduct() {
            this.$refs.topicSelectorDrawer.show();
        },
        onSelectTopic(topicItem) {
            this.dataItem.productName = topicItem.title;
        },
        onChangeIdCardImgs(data) {
            this.dataItem.idCardImg1 = data.frontImage;
            this.dataItem.idCardImg2 = data.backImage;
        },
        onChangePhotoForCredential(values) {
            this.dataItem.idPhoto = values;
        },
        onChangeArea({ selectedOptions }) {
            this.areaSelectingPopup.visible = false;
            this.dataItem.region = selectedOptions[0].value + selectedOptions[1].value + selectedOptions[2].value;
            this.areaSelectingPopup.fieldValue = selectedOptions.map((option) => option.text).join('/');
        },
        saveDraft() {
            storageManager.setItem('draftForRegisterInformation', JSON.stringify(this.dataItem));
            appHelper.showHint('保存成功');
        },
        // setWechatShare : function() {
        //
        //     // 检查登录后和加载数据后执行，必要条件：详情数据、已检查登录状态
        //
        //     if (!this.dataItem || !this.userInstance)
        //     {
        //         return;
        //     }
        //
        //     // var content = data.data.content;
        //     // let desc = htmlHelper.decode(this.dataItem.content);
        //     // desc = htmlHelper.removeTag(desc);
        //     // desc = htmlHelper.removeLineBreak(desc);
        //     // desc = htmlHelper.removeSpace(desc);
        //     // if (desc.length > 20) {
        //     //     desc = desc.substr(0, 20) + '...'
        //     // }
        //     //
        //     // let imageUrl = this.dataItem.imgList ? this.dataItem.imgList[0] : appHelper.getAppIcon();
        //
        //     let link = '';
        //
        //     if (!this.userInstance)
        //     {
        //         link = appHelper.generateShareUrl('/me/registerInformation/add');
        //     }
        //     else
        //     {
        //         link = appHelper.generateShareUrl('/me/registerInformation/add/promotion/:promotionCode', {
        //             ':promotionCode' : this.userInstance.introduceCode
        //         });
        //     }
        //
        //     const wechatShareOptions = {
        //         title   : appHelper.getTitle(),
        //         desc    : this.description,
        //         link    : link,
        //         // imgUrl  : imageUrl
        //     };
        //     wechatHelper.setShare(wechatShareOptions);
        // },
        submit() {

            if (!this.checkRequired())
            {
                consoleApi.log('表达填写不完整');
                return;
            }
            this.dataItem.type = config.informationType;

            this.dataItem.birthday = this.specialFormData.birthday;
            this.dataItem.payTime = this.specialFormData.payTime.replace('T', ' ');
            // YYYY-MM-DD HH:mm:ss
            if (this.dataItem.payTime.length < 19)
            {
                this.dataItem.payTime += ':00'
            }
            if (!this.dataItem.salesmanId)
            {
                this.dataItem.salesmanId = storageManager.getItem('promotion_from') || '';
            }
            this.save();
            storageManager.removeItem('draftForRegisterInformation');
        },
        checkRequired() {
            if (!this.specialFormData.birthday)
            {
                appHelper.showHint('请选择生日日期');
                return false;
            }
            if (!this.specialFormData.payTime)
            {
                appHelper.showHint('请选择支付时间');
                return false;
            }
            if (!this.dataItem.idCardImg1 || !this.dataItem.idCardImg2)
            {
                appHelper.showHint('请上传身份证照片');
                return false;
            }
            if (!this.dataItem.idPhoto)
            {
                appHelper.showHint('请上传证件照片');
                return false;
            }

            return true;
        },
        onSubmitSuccess() {
            appHelper.showHint('提交成功');
            timerManager.setTimeout(() => {
                appHelper.goToPage('registerInformation');
            }, 2 * 1000);
        }
    },
    mounted() {

        const me = this;

        // set default value
        this.dataItem.birthday = moment().format('YYYY-MM-DD');
        this.dataItem.payTime  = moment().format('YYYY-MM-DD 00:00:00');

        let draft = storageManager.getItem('draftForRegisterInformation');
        if (draft)
        {
            try {
                me.dataItem = JSON.parse(draft) || me.dataItem;

                try {
                    me.dataItem.sex = parseInt(me.dataItem.sex);
                }
                catch(e)
                {
                    consoleApi.logError(e);
                }

                me.onLoadDataItem();
            }
            catch(e)
            {
                consoleApi.logError(e);
            }
        }

        const promotionCode = this.$route.params.promotionCode || "";
        promotionCode ? this.dataItem.salesmanId = promotionCode : null;

        appHelper.checkLogin((error, result) => {

            if (error)
            {
                return;
            }
            if (result)
            {
                me.userInstance = userUtil.createUser(result);
                me.setWechatShare({
                    params : {
                        promotionCode : result.introduceCode
                    }
                });

                me.dataItem.userCode = me.userInstance.introduceCode;
            }
            else {
                me.setWechatShare();
            }
        }, {
            promotionCode: promotionCode,
        });

        let id = appHelper.getRouteParam(this, 'id');
        id ? this.loadDataItem(id) : null;

        // this.dataItem = {
        //     address : 'g23g23gegwegwegwegweg',
        //     birthday : '2023-01-01',
        //     education : 2,
        //     idCard : '',
        //     idCardImg1 : '',
        //     idCardImg2 : '',
        //     idPhoto : '',
        //     name : 'wehwehweh2323',
        //     productName : 'wegwegwegweg',
        //     orderAccount : 'rehh34h',
        //     orderNo : '3g23g23g23g',
        //     payAmount : '2345',
        //     payTime : '2023-01-01 00:00:00',
        //     payWay : 2,
        //     phone : '23523646',
        //     profession : 1,
        //     region : 'awhaerwhaerh',
        //     sex : 0,
        //     unitOfCertificate : '人事人才',
        //     userCode : '73116936',
        //     wxNo : '3g23g23g'
        // }
    }
}
</script>

<style lang="scss" scoped>
.green {
    color: #0FC060
}
.color888 {
    color: #888;
}
.point {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 7px;
    line-height: 15px;
    overflow: hidden;
}
.startPoint {
    background: #0FC060;
}
.endPoint {
    background: #888;
}
.formRow {
    display: flex;
    padding: 10px 0;
    //height: 30px;
    line-height: 30px;
    .columnName {
        color: #5B616C;
        width: 72px;
    }
    .columnValue {
        flex: 1;
        .inputbox {
            //display: block;
            //width: 100%;
            font-size: 16px;
            height: 27px;
            line-height: 27px;
            border: none;
            background: transparent;
            color: hsla(0, 0%, 20%, 1);
            outline: none;
        }
        .inputbox::placeholder,
        .inputbox::-webkit-input-placeholder,
        .inputbox::-moz-placeholder,
        .inputbox::-ms-input-placeholder {
            color: hsla(220, 27%, 78%, 1);
        }
    }
}
.selectbox {
    border: none 0;
}
.saveDraftButton {
    height: 40px;
    line-height: 40px;
    border: solid 1px #E68C20;
    background: white;
    box-sizing: border-box;
    color: #E68C20;
}
.submitButton {
    height: 40px;
    line-height: 40px;
    background: #E68C20;
    box-sizing: border-box;
    border: none 0;
    color: white;
}
</style>
